import React from 'react';
import { Skeleton } from '@patternfly/react-core';
import { LandingLayout } from 'components/Landing/LandingLayout';

type SidebarSkeletonProps = {
  /** When false, omits the metadata section (e.g. for Premium session landing) */
  showMetadata?: boolean;
  /** When false, omits the community section (e.g. for Skills Path landing) */
  showCommunity?: boolean;
};

const SidebarSkeleton: React.FC<SidebarSkeletonProps> = ({
  showMetadata = true,
  showCommunity = true,
}) => (
  <>
    <LandingLayout.SidebarActions>
      <Skeleton width="100%" height="40px" />
    </LandingLayout.SidebarActions>

    {showMetadata && (
      <LandingLayout.Metadata>
        <div
          style={{
            height: '400px',
            display: 'flex',
            flexDirection: 'column',
            gap: 'var(--pf-v5-global--spacer--md)',
          }}
        >
          {[1, 2, 3, 4].map((i) => (
            <LandingLayout.MetadataWithIcon key={i} isSkeleton>
              <div className="overview__metadata-text">
                <Skeleton height="20px" width={`${110 + (i % 3) * 10}px`} />
              </div>
            </LandingLayout.MetadataWithIcon>
          ))}

          <Skeleton width="100%" height="90px" />
        </div>
      </LandingLayout.Metadata>
    )}

    {showCommunity && (
      <LandingLayout.Community>
        <Skeleton width="90%" height="20px" />
        <Skeleton width="100%" height="34px" />
        <Skeleton width="100%" height="36px" />
      </LandingLayout.Community>
    )}
  </>
);

export default SidebarSkeleton;
